import React from "react";

export const Pill = ({ children, tone = "slate", testId }) => {
  const tones = {
    slate: "bg-slate-100 text-slate-800 border-slate-200",
    violet: "bg-violet-50 text-violet-800 border-violet-200",
    amber: "bg-amber-50 text-amber-900 border-amber-200",
    emerald: "bg-emerald-50 text-emerald-900 border-emerald-200",
    rose: "bg-rose-50 text-rose-900 border-rose-200",
  };
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center rounded-full border px-2.5 py-1 text-xs font-medium ${tones[tone]}`}
    >
      {children}
    </span>
  );
};
